/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_CardInputs */



/**
* | output |
* | --- |
* | "Update Card" |
*
* @param {Update_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_card = /** @type {((inputs?: Update_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Carte de mise à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierungskarte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna la scheda")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Карта обновления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tarjeta de actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新卡")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カードを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्ड अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cartão de atualização")
	return /** @type {LocalizedString} */ ("Update Card")
});